import { FC } from 'react';
import { Button } from '@edikk-edikk/ui';
import contentItemCss from '#srcCssModules/advert/list-filter/advert-list-filter-content-item.module.scss';
import { useFilterContext } from '#advertList/components/filter/hooks/use-filter-context';
import { FilterItem } from '#advertList/components/filter/types/FilterItem';

type PropsType = {
  filterItem: FilterItem;
};

const FilterItemDetail: FC<PropsType> = ({
  filterItem,
}) => {
  const { onChangeSubject } = useFilterContext();

  return (
    <Button
      variant="unstyled"
      navLinkProps={{
        to: filterItem.url,
        state: { routerConfig: filterItem.routerConfig.getData() },
        end: true,
        onClick: () => {
          onChangeSubject.next(filterItem.url);
        },
        className: contentItemCss.advertListFilterContentItem,
        activeClassName: contentItemCss.advertListFilterContentItem_active,
      }}
    >
      <div className={contentItemCss.advertListFilterContentItem__content}>
        <div>
          {filterItem.getVisibleName()}
        </div>
        <div className={contentItemCss.advertListFilterContentItem__counter}>
          (
          {filterItem.numberOfAdverts}
          )
        </div>
      </div>
    </Button>
  );
};

export { FilterItemDetail };
